﻿window.cMsgEmailSms = function (bddRef) {
    var Me = this;
    var dsNbEmail = null;
    var oldDsNbEmail = null;
    var dsNbEmailErreur = null;
    var oldDsNbEmailErreur = null;
    var nbEmailErreur = {};

    //var dsNbSms = null;
    //var oldDsNbSms = null;

    this.mStart = function () { Me.mGetData() }

    var tempoGetData = 120000
    var timeOutGetData = null

    var hasClickBody = false
    $(window).on("click.msgEmail", function (e) { hasClickBody = true });

    var timeOutUpdate = null
    bddRef.mAddFunctionOnModifiedItemData(["com_email_recu"], $("body"),
        function (action, itemData) {
            window.clearTimeout(timeOutUpdate)
            timeOutUpdate = window.setTimeout(function () { Me.mGetData(true) }, 500)
        })
    bddRef.mAddFunctionOnModifiedItemData(["rappel", "rappel_utilisateur"], $DivGeneral,
        function (action, itemData) {
            window.clearTimeout(timeOutUpdate)
            timeOutUpdate = window.setTimeout(function () { Me.mGetData(true) }, 500)
        })

    var msgDesactivationIsDisplayed = false
    this.mMsgDesactivation = function () {
        if (typeof bddRef.utiCourant == 'undefined' || bddRef.utiCourant == null) return
        if (!msgDesactivationIsDisplayed) {
            msgDesactivationIsDisplayed = true

            var lstCpteEmailReceptionEnvoiPrevenirOAuth = bddRef.getObjet(bddRef.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (o) { return (o.reception_prevenir_desactivation == "1" || o.envoi_prevenir_desactivation == "1") && o.statut_token_oauth_deconnect != 0 })
            if (lstCpteEmailReceptionEnvoiPrevenirOAuth.length > 0 && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                messagePopup.mShow({
                    bddCtrl: bddRef,
                    titre: "Authentification Gmail désactivé",
                    message: function (contentElement, popup) {
                        lstCpteEmailReceptionEnvoiPrevenirOAuth.forEach(function (dataCpteEmail, idx) {
                            var $DivCptEmail = $("<div/>").appendTo(contentElement)
                            if (idx > 0) $("<hr/>").appendTo($DivCptEmail)
                            var $DivClick = null
                            switch (parseInt(dataCpteEmail.statut_token_oauth_deconnect)) {
                                case 1://gmail_reception
                                    $DivClick = $("<div style='font-size:100%;padding:10px;' class='state-hover'>La <b>réception</b> sur l'adresse email <u>" + dataCpteEmail.adresse_email + "</u> via votre connexion oAuth a été désactivé. Cliquez pour la réactiver.</div>").appendTo($DivCptEmail)
                                    break;
                                case 2://gmail_envoi
                                    $DivClick = $("<div style='font-size:100%;padding:10px;' class='state-hover'>Les <b>envois</b> sur l'adresse email <u>" + dataCpteEmail.adresse_email + "</u> via votre connexion oAuth a été désactivé. Cliquez pour la réactiver.</div>").appendTo($DivCptEmail)
                                    break;
                                case 3://gmail_reception_envoi
                                    $DivClick = $("<div style='font-size:100%;padding:10px;' class='state-hover'>La <b>réception et l'envoi</b> sur l'adresse email <u>" + dataCpteEmail.adresse_email + "</u> via votre connexion oAuth a été désactivé. Cliquez pour la réactiver.</div>").appendTo($DivCptEmail)
                                    break;
                            }
                            $DivClick.on("click", function (e) {
                                mCreateTokenEmailGmail({
                                    bddCtrl: bddRef,
                                    onStart: function () { },
                                    onValide: function (dataCompteEmailOauth, dataCompteEmailUtilisateur) {
                                        if (dataCompteEmailOauth.id_compte_email == dataCpteEmail.id_compte_email) {
                                            dataCpteEmail = dataCompteEmailOauth
                                            switch (parseInt(dataCpteEmail.statut_token_oauth_deconnect)) {
                                                case 1://gmail_reception
                                                    dataCompteEmailOauth.reception_actif = 1
                                                    break;
                                                case 2://gmail_envoi
                                                    dataCompteEmailOauth.envoi_actif = 1
                                                    break;
                                                case 3://gmail_reception_envoi
                                                    dataCompteEmailOauth.reception_actif = 1
                                                    dataCompteEmailOauth.envoi_actif = 1
                                                    break;
                                            }
                                            dataCompteEmailOauth.envoi_derniere_erreur_cnx = null
                                            dataCompteEmailOauth.reception_derniere_erreur_cnx = null
                                            dataCompteEmailOauth.reception_prevenir_desactivation = "0"
                                            dataCompteEmailOauth.envoi_prevenir_desactivation = "0"
                                            dataCompteEmailOauth.statut_token_oauth_deconnect = "0"
                                            bddRef.getObjet(dataCompteEmailOauth).mSave()
                                        }
                                    },
                                    onCancel: function () {
                                    }
                                })

                                lstCpteEmailReceptionEnvoiPrevenirOAuth.splice(lstCpteEmailReceptionEnvoiPrevenirOAuth.indexOf(dataCpteEmail), 1)
                                $DivCptEmail.remove()
                                if (lstCpteEmailReceptionEnvoiPrevenirOAuth.length == 0) {
                                    popup.hide()
                                }
                            })
                        })

                        //$("<br/>").appendTo(contentElement)
                        var $Div = $("<div style='text-align:right;font-size:80%;padding:0 0 10px 0;'></div>").appendTo(contentElement)
                        $A = $("<a href='javascript:void(0)'>J'ai compris</a>").appendTo($Div)
                        $A.attr("title", "J'ai compris le message.<br/>Ne plus afficher cette information.")
                        $A.on("click", function () {
                            lstCpteEmailReceptionPrevenir.forEach(function (dataCpt) {
                                dataCpt.reception_prevenir_desactivation = "0"
                                dataCpt.envoi_prevenir_desactivation = "0"
                                dataCpt.statut_token_oauth_deconnect = "0"
                                bddRef.getObjet(dataCpt).mSave()
                            })
                            popup.hide()
                        })
                    },
                    tempoSeconde: 20
                })
            }

            var lstCpteEmailReceptionPrevenir = bddRef.getObjet(bddRef.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (o) {
                return o.reception_prevenir_desactivation == "1" && !lstCpteEmailReceptionEnvoiPrevenirOAuth.contains(o)
            })
            if (lstCpteEmailReceptionPrevenir.length > 0 && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                messagePopup.mShow({
                    bddCtrl: bddRef,
                    titre: "Réception désactivé",
                    message: function (contentElement, popup) {
                        if (lstCpteEmailReceptionPrevenir.length == 1) {
                            $("<div style='font-size:80%;'>La réception sur l'adresse email ci-dessous a été désactivée par l'application suite à une impossibilité de se connecter au serveur de mail durant un certain temps. Veuillez vérifier votre configuration pour relancer la réception sur cette adresse email.</div>").appendTo(contentElement)
                        } else {
                            $("<div style='font-size:80%;'>La réception sur les adresses emails ci-dessous a été désactivée par l'application suite à une impossibilité de se connecter au serveur de mail durant un certain temps. Veuillez vérifier la configuration pour relancer la réception sur ces adresses emails.</div>").appendTo(contentElement)
                        }
                        $("<br/>").appendTo(contentElement)
                        lstCpteEmailReceptionPrevenir.forEach(function (dataCpt) {
                            var $DivEle = $("<div style='border:" + theme.border + ";padding:10px;'/>").appendTo(contentElement)
                            bddRef.getObjet(dataCpt).objetMetier.templateTitleEmail($DivEle, bddRef.utiCourant.id_utilisateur, { showReception: true })
                        })
                        $("<br/>").appendTo(contentElement)
                        var $Div = $("<div style='text-align:right;font-size:80%;padding:10px 0;'></div>").appendTo(contentElement)
                        $A = $("<a href='javascript:void(0)'>J'ai compris</a>").appendTo($Div)
                        $A.attr("title", "J'ai compris le message.<br/>Ne plus afficher cette information.")
                        $A.on("click", function () {
                            lstCpteEmailReceptionPrevenir.forEach(function (dataCpt) {
                                dataCpt.reception_prevenir_desactivation = "0"
                                bddRef.getObjet(dataCpt).mSaveChamp("reception_prevenir_desactivation")
                            })
                            popup.hide()
                        })
                    },
                    tempoSeconde: 20
                })
            }
            var lstCpteEmailEnvoiPrevenir = bddRef.getObjet(bddRef.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (o) {
                return o.envoi_prevenir_desactivation == "1" && !lstCpteEmailReceptionEnvoiPrevenirOAuth.contains(o)
            })
            if (lstCpteEmailEnvoiPrevenir.length > 0 && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                messagePopup.mShow({
                    bddCtrl: bddRef,
                    titre: "Envoi SMTP perso désactivé",
                    message: function (contentElement, popup) {
                        if (lstCpteEmailEnvoiPrevenir.length == 1) {
                            $("<div style='font-size:80%;'>L'envoi via le SMTP spécifique sur l'adresse email ci-dessous a été désactivée par l'application suite à une impossibilité de se connecter au serveur de mail durant un certain temps. Veuillez vérifier votre configuration pour relancer l'envoi via le SMTP spécifique sur cette adresse email.</div>").appendTo(contentElement)
                        } else {
                            $("<div style='font-size:80%;'>L'envoi via le SMTP spécifique sur les adresses emails ci-dessous a été désactivée par l'application suite à une impossibilité de se connecter au serveur de mail durant un certain temps. Veuillez vérifier votre configuration pour relancer l'envoi via le SMTP spécifique sur ces adresses emails.</div>").appendTo(contentElement)
                        }
                        $("<br/>").appendTo(contentElement)
                        lstCpteEmailEnvoiPrevenir.forEach(function (dataCpt) {
                            var $DivEle = $("<div style='border:" + theme.border + ";padding:10px;'/>").appendTo(contentElement)
                            bddRef.getObjet(dataCpt).objetMetier.templateTitleEmail($DivEle, bddRef.utiCourant.id_utilisateur, { showEnvoi: true })
                        })
                        $("<br/>").appendTo(contentElement)
                        var $Div = $("<div style='text-align:right;font-size:80%;padding:10px 0;'></div>").appendTo(contentElement)
                        $A = $("<a href='javascript:void(0)'>J'ai compris</a>").appendTo($Div)
                        $A.attr("title", "J'ai compris le message.<br/>Ne plus afficher cette information.")
                        $A.on("click", function () {
                            lstCpteEmailEnvoiPrevenir.forEach(function (dataCpt) {
                                dataCpt.envoi_prevenir_desactivation = "0"
                                bddRef.getObjet(dataCpt).mSaveChamp("envoi_prevenir_desactivation")
                            })
                            popup.hide()
                        })
                    },
                    tempoSeconde: 20
                })
            }

        }
    }

    var LstIdComEmailRecuVisu = []
    this.mUpdateLstIdComEmailRecuVisu = function (dataGrid) {
        const idSet = new Set(LstIdComEmailRecuVisu);
        for (const item of dataGrid) {
            if (!idSet.has(item.id)) {
                idSet.add(item.id);
                LstIdComEmailRecuVisu.push(item.id);
            }
        }
        //dataGrid.filter(function (o) {
        //    return LstIdComEmailRecuVisu.filter(function (oo) { return o.id == oo.id }).length == 0
        //}).forEach(function (itemData) { LstIdComEmailRecuVisu.push(itemData.id) })
    }
    var LstIdComSmsRecuVisu = []
    this.mUpdateLstIdComSmsRecuVisu = function (dataGrid) {
        dataGrid.filter(function (o) {
            return LstIdComSmsRecuVisu.filter(function (oo) { return o.id == oo.id }).length == 0
        }).forEach(function (itemData) { LstIdComSmsRecuVisu.push(itemData.id) })
    }

    this.mGetNbEmail = function (lstIdTypeClassement, adrMail, nouveau) {
        if (typeof nouveau == "undefined") nouveau = null
        if (typeof lstIdTypeClassement == 'undefined') lstIdTypeClassement = null
        if (typeof adrMail == 'undefined') adrMail = null
        var value = 0
        if (dsNbEmail != null) dsNbEmail.filter(function (o) {
            return (lstIdTypeClassement == null || lstIdTypeClassement.contains(o.id_type_classement)) &&
                ((adrMail == null && o.adresse_email.toLowerCase() != "favori") || (adrMail != null && o.adresse_email == adrMail.toLowerCase())) &&
                (nouveau == null || (nouveau == "1" && o.nouveau == "1") || (nouveau == "-2" && o.nouveau == "-2"))
        }).forEach(function (o) { value += parseInt(o.nb) })
        return value
    }
    this.mGetDsEmailErreur = function (adrMail, presentationMailing, lstIdTypeClassement) {
        var value = {
            nb: 0,
            lstData: []
        }
        if (dsNbEmailErreur != null && dsNbEmailErreur.filter(function (o) {
            return ((adrMail == null) ? o.adresse_email != "favori" : o.adresse_email == adrMail) &&
                ((typeof presentationMailing == 'undefined' || presentationMailing == null) ? true : o.presentation_mailing == presentationMailing) &&
                (!lstIdTypeClassement || lstIdTypeClassement.contains(o.id_type_classement))
        }).length > 0) {
            //value = parseInt(dsNbEmailErreur.filter(function (o) {
            //    return o.adresse_email == adrMail &&
            //        ((typeof presentationMailing == 'undefined') ? true : o.presentation_mailing == presentationMailing)
            //})[0].nb_error)
            dsNbEmailErreur.filter(function (o) {
                return ((adrMail == null) ? o.adresse_email != "favori" : o.adresse_email == adrMail) &&
                    ((typeof presentationMailing == 'undefined' || presentationMailing == null) ? true : o.presentation_mailing == presentationMailing) &&
                    (!lstIdTypeClassement || lstIdTypeClassement.contains(o.id_type_classement))
            }).forEach(function (o) {
                value.nb += parseInt(o.nb_error)
                value.lstData.push(o)
            })

        }
        return value
    }

    var lstHistoMailErreur = []
    var firstDisplayDemarrage = true
    var dateLastGetData = null
    var nbCallSansClick = 0
    this.mGetData = function (forcer) {
        window.clearTimeout(timeOutGetData)
        if (hasClickBody || nbCallSansClick > 10 || forcer || dsNbEmail == null) {
            hasClickBody = false
            nbCallSansClick = 0;
            //console.log("GETDATA")
            dateLastGetData = new Date()
            if (dsNbEmail != null) {
                oldDsNbEmail = JSON.parse(JSON.stringify(dsNbEmail))
                oldDsNbEmailErreur = JSON.parse(JSON.stringify(dsNbEmailErreur))
            }
            this.mMsgDesactivation()
            bddRef.mAjaxCall({
                command: "getnbemailsmsclickvue",
                last_id_com_email_recu: bddRef.utiCourantParaJson.last_id_com_email_recu,
                last_id_com_email_envoi_tracking_vue: bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_vue,
                last_id_com_email_envoi_tracking_click: bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_click,
                last_id_com_sms_envoi_tracking_vue: bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_vue,
                last_id_com_sms_envoi_tracking_click: bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_click,
                getdoccptpa: (firstDisplayDemarrage ? "1" : "0")
            }, function (data) {
                var resultDs = []

                if (data.lststrconsansinteraction && data.lststrconsansinteraction.length > 0) {
                    //il y a des contacts sans interaction
                    if (firstDisplayDemarrage) {
                        resultDs.push({
                            title: "<div>RGPD: Vous avez <b>" + data.lststrconsansinteraction.length + "</b> contact" + (data.lststrconsansinteraction.length > 1 ? "s" : "") + " sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans</div>",
                            icon: "fas fa-magnifying-glass-chart",
                            lstData: null,
                            funcRempli: function (lstData, contentElement, titleElementText) {
                                var $Table = $("<table style='width:100%;font-family:barlow condensed;'/>").appendTo(contentElement)
                                var $Tr = $("<tr/>").appendTo($Table)
                                var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                                $("<div/>").appendTo($Td).html("Contacts sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans : le RGPD impose leur suppression, sauf échange récent à signaler.<br/>Pour conserver un contact, ajoutez une note d’interaction sur sa fiche, ou une note groupée si vous avez eu un échange commun avec tous les contacts listés.")
                                var $Td = $("<td style='width:1px;text-align:center;'/>").appendTo($Tr)
                                var $Div = $("<div style='padding:2px 0;'/>").appendTo($Td)
                                var $A = $("<a href='javascript:void(0)' style='white-space:nowrap;'>Supprimer tous</a>").appendTo($Div)
                                $A.attr("title", "Mettre à la corbeille tous les contacts.")
                                $A.on("click", function (e) {
                                    var lstDataTraitement = dxGrisStrConRgpd.mGetLstData()
                                    if (lstDataTraitement.length > 0) {
                                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                            target: target,
                                            contentTemplate: function (contentElement) {
                                                contentElement.css("padding", "24px");
                                                $("<div>Mettre à la corbeile " + lstDataTraitement.length + " élément" + ((lstDataTraitement.length > 1) ? "s" : "") + "</div>").appendTo(contentElement)
                                                $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                                    text: "Confirmer",
                                                    onClick: function (e) {
                                                        tt.hide()
                                                        if (lstDataTraitement.length <= 10) {
                                                            Me.activeOnModifiedItemData = false
                                                            jaugeDemarrage.mShow();

                                                            var data = []
                                                            lstDataTraitement.forEach(function (ligne) {
                                                                data.push({
                                                                    id_table: ligne.id_table,
                                                                    id: ligne.id
                                                                })
                                                            })
                                                            var funcDelete = function (idx) {
                                                                if (typeof data[idx] == 'undefined') {
                                                                    jaugeDemarrage.mHide();
                                                                    Me.activeOnModifiedItemData = true
                                                                    mNotify("Les données ont été mises à la corbeille.", "success", 6000)
                                                                    titleElementText.html("<div>RGPD: Vous avez <b>0</b> contact sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans</div>")
                                                                    dxGrisStrConRgpd.mChangeLstIdTableIdInclu([{ id_table: 0, id: 0 }])
                                                                } else {
                                                                    var nomTable = option.bddCtrl.table.mGetItem(data[idx].id_table).nom
                                                                    var obj = option.bddCtrl.getObjet(nomTable, data[idx].id)
                                                                    obj.mDelData(function () {
                                                                        //dxGrid.mRemoveRow(lstData[idx])
                                                                        funcDelete(idx + 1)
                                                                    }, null, true, null, function () {
                                                                        jaugeDemarrage.mHide();
                                                                        Me.activeOnModifiedItemData = true
                                                                        mNotify("Une erreur s'est produite durant la mise à la corbeille. Une partie des données n'a pas été mise à la corbeille.", "error", 6000)
                                                                        dxGrisStrConRgpd.mChangeLstIdTableIdInclu([{ id_table: 0, id: 0 }])
                                                                    })
                                                                }
                                                            }
                                                            funcDelete(0)
                                                        } else {
                                                            var data = []
                                                            lstDataTraitement.forEach(function (ligne) {
                                                                data.push({
                                                                    id_table: ligne.id_table,
                                                                    id: ligne.id
                                                                })
                                                            })
                                                            var trait = new cTraitementBloquantSession(option.bddCtrl, {
                                                                nom_type_traitement: "deldanscorbeillelot",
                                                                data: data
                                                            }, {
                                                                onFinTraitement: function () {
                                                                    titleElementText.html("<div>RGPD: Vous avez <b>0</b> contact sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans</div>")
                                                                    dxGrisStrConRgpd.mChangeLstIdTableIdInclu([{ id_table: 0, id: 0 }])
                                                                }
                                                            });
                                                        }
                                                    }
                                                })
                                            }
                                        }).dxCtrlTooltip("instance");
                                        tt.show();
                                    }
                                })

                                var $Div = $("<div style='padding:2px 0;'/>").appendTo($Td)
                                var $A = $("<a href='javascript:void(0)' style='white-space:nowrap;'>Ecrire note sur tout</a>").appendTo($Div)
                                $A.attr("title", "En rédigeant une note pour tous ces contacts, vous créer une interaction qui fera disparaitre la fiche des contacts de cette liste.")
                                $A.on("click", function (e) {
                                    bddRef.getObjet("com_note").objetMetier.mCreateNote("", data.lststrconsansinteraction, function (idComNote) {
                                        bddRef.mAjaxCall({
                                            command: "recalculgenstrconidtableid",
                                            lstdataidtableid: data.lststrconsansinteraction
                                        })
                                        dxGrisStrConRgpd.mChangeLstIdTableIdInclu([{ id_table: 0, id: 0 }])
                                        bddRef.getObjet("com_note", idComNote).mShowPopup()
                                        titleElementText.html("<div>RGPD: Vous avez <b>0</b> contact sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans</div>")
                                    })
                                })

                                //var $Div = $("<div style='padding:2px 0;'/>").appendTo($Td)
                                //var $A = $("<a href='javascript:void(0)' style='white-space:nowrap;'>Emailing sur tout</a>").appendTo($Div)
                                //$A.attr("title", "Vous pouvez envoyer un emailing sur tous ces contacts pour les avertir que leur données vont-être suprimées.<br/>Vous pouvez leur proposer de réactiver leurs données en leur proposant de cliquer sur un lien.<br/>Le fait de cliquer sur un lien réactivera les données et fera disparaitre la fiche de cette liste.")
                                //$A.on("click", function (e) {
                                //    e.stopPropagation()

                                //})

                                var $Div = $("<div style='padding:2px 0;'/>").appendTo($Td)
                                var $A = $("<a href='javascript:void(0)' style='white-space:nowrap;'>Paramètre RGPD</a>").appendTo($Div)
                                $A.on("click", function (e) {
                                    e.stopPropagation()
                                    $("<div/>").appendTo("body").dxCtrlParaAppli({
                                        selectedKey: "rgpd_nbre_annee_conservation_donnees",
                                        bddCtrl: bddRef,
                                        isInPopup: true
                                    })
                                })

                                var dxGrisStrConRgpd = $("<div/>").appendTo(contentElement).dxCtrlGridStrCon({
                                    bddCtrl: bddRef,
                                    context_grid: "controle_rgpd4",
                                    hideEntete: true,
                                    noPagination: true,
                                    field_sort: "last_date_interaction",
                                    lstIdTableIdInclu: data.lststrconsansinteraction,
                                    itemTemplateGrille: function (container, dataTemplate, type, optionTemplate) {
                                        var $Div = $("<div style='white-space:nowrap; overflow:hidden;text-overflow:ellipsis;' />").appendTo(container)
                                        $Div.text([
                                            dataTemplate.nom_str,
                                            [dataTemplate.con_nom, dataTemplate.con_prenom].filter(v => v != null && v.trim() !== "").join(" "),
                                            dataTemplate.adresse_email
                                        ].filter(v => v != null && v.trim() !== "").join(" / "));
                                        var $Div = $("<div style='font-family:barlow condensed;'/>").appendTo(container)
                                        $("<span title='Derniere interaction le " + dataTemplate.last_date_interaction.toDDMMAAAA() + "'/>").appendTo($Div).text(dataTemplate.last_date_interaction.toDateIlya(true))
                                        $("<span> &bull; </span>").appendTo($Div)
                                        var $A = $("<a href='javascript:void(0)'>Saisir une note</a>").appendTo($Div)
                                        $A.attr("title", "En rédigeant une note pour ce contact, vous créer une interaction qui fera disparaitre la fiche du contact de cette liste.")
                                        $A.on("click", function (e) {
                                            e.stopPropagation()
                                            var lstItem = data.lststrconsansinteraction.filter(function (o) { return o.id_table == dataTemplate.id_table_key && o.id == dataTemplate.id_key })
                                            bddRef.getObjet("com_note").objetMetier.mCreateNote("", lstItem, function (idComNote) {
                                                bddRef.mAjaxCall({
                                                    command: "recalculgenstrconidtableid",
                                                    lstdataidtableid: lstItem
                                                })
                                                data.lststrconsansinteraction.splice(data.lststrconsansinteraction.indexOf(lstItem[0]), 1)
                                                dxGrisStrConRgpd.mChangeLstIdTableIdInclu(data.lststrconsansinteraction)
                                                titleElementText.html("<div>RGPD: Vous avez <b>" + data.lststrconsansinteraction.length + "</b> contact" + (data.lststrconsansinteraction.length > 1 ? "s" : "") + " sans interaction depuis plus de " + bddRef.paraAppli.mGetPara("rgpd_nbre_annee_conservation_donnees") + " ans</div>")
                                                bddRef.getObjet("com_note", idComNote).mShowPopup()
                                            })
                                        })
                                        //$("<span> &bull; </span>").appendTo($Div)
                                        //var $A = $("<a href='javascript:void(0)'>Supprimer le contact</a>").appendTo($Div)
                                        //$A.on("click", function (e) {
                                        //    e.stopPropagation()
                                        //})
                                    }
                                }).dxCtrlGridStrCon("instance")
                            }
                        })
                    }
                }

                //rappel
                if (bddRef.objCptCli.objetMetier.hasAgenda()) {
                    var dsRappel = mGetDataSourceRappel()
                    if (dsRappel.length > 0) {
                        var lstIdRappel = []
                        dsRappel.forEach(function (dataRappel) { lstIdRappel.push(dataRappel.id_rappel) })
                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div>Vous avez <b>" + dsRappel.length + "</b>" + (dsRappel.length > 1 ? " nouveaux rappels" : " nouveau rappel") + " en attente</div>",
                                icon: "fas fa-bell",
                                lstData: dsRappel,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("padding-left", "30px")
                                    var height = 0
                                    var emoji = "🔔"
                                    $("<div/>").appendTo(contentElement).dxCtrlGridRappel({
                                        bddCtrl: bddRef,
                                        context_grid: "rappelpopup",
                                        lstIdRappel: lstIdRappel,
                                        hideEntete: true,
                                        noPagination: true
                                    })
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "rappel",
                                tempoSeconde: 15 + dsRappel.length * 2,
                                icone: "<i class='fas fa-bell' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    $("<div>Vous avez <b>" + dsRappel.length + "</b>" + (dsRappel.length > 1 ? " nouveaux rappels" : " nouveau rappel") + "</div>").appendTo(contentElement)

                                    var dxGridRap = $("<div/>").appendTo(contentElement).dxCtrlGridRappel({
                                        bddCtrl: bddRef,
                                        lstIdRappel: lstIdRappel,
                                        context_grid: "rappelpopup",
                                        hideEntete: true,
                                        noPagination: true,
                                        noGroup: true
                                    }).dxCtrlGridRappel("instance")
                                    dxGridRap.element().css("height", lstIdRappel.length * 65)
                                    var height = dxGridRap.element().innerHeight()
                                    if (height > $(document).height() / 3) { dxGridRap.element().css("height", ($(document).height() / 3) + "px") }
                                }
                            })
                        }
                    }
                }

                //sondage
                if (bddRef.objCptCli.objetMetier.hasSondage()) {
                    var dsSondageRep = mGetDataSourceSondage()
                    if (dsSondageRep.length > 0) {
                        var lstIdsondageReponse = []
                        var idTableSondRep = bddRef.table.mGetItemFromNom("sondage_reponse").id_table
                        dsSondageRep.forEach(function (dataSondageRep) {
                            lstIdsondageReponse.push({
                                id_table: idTableSondRep,
                                id: dataSondageRep.id_sondage_reponse
                            })
                        })
                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div>Vous avez <b>" + dsSondageRep.length + "</b>" + (dsSondageRep.length > 1 ? " réponses sondage" : " réponses sondage") + " non vue" + (dsSondageRep.length > 1 ? "s" : "") + "</div>",
                                icon: "fas fa-clipboard-question",
                                lstData: null,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("position", "relative")
                                    $("<div style='position:absolute;top:0;right:0;z-index:1;'/>").appendTo(contentElement).dxCtrlButton({
                                        icon: "fas fa-eye",
                                        hint: "Tout marquer comme vue",
                                        onClick: function (e) {
                                            var lstId = ""
                                            lstIdsondageReponse.forEach(function (o) { lstId += (lstId.length > 0 ? "," : "") + o.id })
                                            bddRef.mModifValueChamp("vue", "sondage_reponse", lstId, "1", function () {
                                                contentElement.closest(".dx-accordion-item").slideUp(200, function () {
                                                    contentElement.closest(".dx-accordion-item").remove()
                                                })
                                            })
                                        }
                                    })
                                    contentElement.css("padding-left", "30px")
                                    $("<div/>").appendTo(contentElement).dxCtrlGridSondageReponse({
                                        bddCtrl: bddRef,
                                        context_grid: "sondagereppopup",
                                        lstIdTableIdInclu: lstIdsondageReponse,
                                        hideEntete: true,
                                        noPagination: true
                                    })
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "rappel",
                                tempoSeconde: 15 + dsRappel.length * 2,
                                icone: "<i class='fas fa-clipboard-question' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    $("<div>Vous avez <b>" + dsSondageRep.length + "</b>" + (dsSondageRep.length > 1 ? " réponses sondage" : " réponses sondage") + " non vue" + (dsSondageRep.length > 1 ? "s" : "") + "</div>").appendTo(contentElement)

                                    var dxGridRap = $("<div/>").appendTo(contentElement).dxCtrlGridSondageReponse({
                                        bddCtrl: bddRef,
                                        context_grid: "sondagereppopup",
                                        lstIdTableIdInclu: lstIdsondageReponse,
                                        hideEntete: true,
                                        noPagination: true,
                                        noGroup: true
                                    }).dxCtrlGridSondageReponse("instance")
                                    dxGridRap.element().css("height", lstIdsondageReponse.length * 65)
                                    var height = dxGridRap.element().innerHeight()
                                    if (height > $(document).height() / 3) { dxGridRap.element().css("height", ($(document).height() / 3) + "px") }
                                }
                            })
                        }
                    }
                }

                //formulaire
                if (parametre.code_appli == "ppmasc") {
                    var dsFormRep = mGetDataSourceFormulaire()
                    if (dsFormRep.length > 0) {
                        var lstIdFormReponse = []
                        var idTableFormRep = bddRef.table.mGetItemFromNom("formulaire_reponse").id_table
                        dsFormRep.forEach(function (dataFormRep) {
                            lstIdFormReponse.push({
                                id_table: idTableFormRep,
                                id: dataFormRep.id_formulaire_reponse
                            })
                        })
                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div>Vous avez <b>" + dsFormRep.length + "</b>" + (dsFormRep.length > 1 ? " réponses formulaire" : " réponses formulaire") + " non vue" + (dsFormRep.length > 1 ? "s" : "") + "</div>",
                                icon: "fafa fafa-formulaire",
                                lstData: null,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("position", "relative")
                                    $("<div style='position:absolute;top:0;right:0;z-index:1;'/>").appendTo(contentElement).dxCtrlButton({
                                        icon: "fas fa-eye",
                                        hint: "Tout marquer comme vue",
                                        onClick: function (e) {
                                            var lstId = ""
                                            lstIdFormReponse.forEach(function (o) { lstId += (lstId.length > 0 ? "," : "") + o.id })
                                            bddRef.mModifValueChamp("vue", "formulaire_reponse", lstId, "1", function () {
                                                contentElement.closest(".dx-accordion-item").slideUp(200, function () {
                                                    contentElement.closest(".dx-accordion-item").remove()
                                                })
                                            })
                                        }
                                    })
                                    contentElement.css("padding-left", "30px")
                                    $("<div/>").appendTo(contentElement).dxCtrlGridFormulaireReponse({
                                        bddCtrl: bddRef,
                                        context_grid: "formreppopup",
                                        lstIdTableIdInclu: lstIdFormReponse,
                                        hideEntete: true,
                                        noPagination: true
                                    })
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "rappel",
                                tempoSeconde: 15 + dsRappel.length * 2,
                                icone: "<i class='fafa fafa-formulaire' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    $("<div>Vous avez <b>" + dsFormRep.length + "</b>" + (dsFormRep.length > 1 ? " réponses formulaire" : " réponses formulaire") + " non vue" + (dsFormRep.length > 1 ? "s" : "") + "</div>").appendTo(contentElement)

                                    var dxGridRap = $("<div/>").appendTo(contentElement).dxCtrlGridFormulaireReponse({
                                        bddCtrl: bddRef,
                                        context_grid: "formreppopup",
                                        lstIdTableIdInclu: lstIdFormReponse,
                                        hideEntete: true,
                                        noPagination: true,
                                        noGroup: true
                                    }).dxCtrlGridSondageReponse("instance")
                                    dxGridRap.element().css("height", lstIdFormReponse.length * 65)
                                    var height = dxGridRap.element().innerHeight()
                                    if (height > $(document).height() / 3) { dxGridRap.element().css("height", ($(document).height() / 3) + "px") }
                                }
                            })
                        }
                    }
                }

                //doccpt
                if (data.lstdoccpt && data.lstdoccpt.length > 0) {
                    resultDs.push({
                        title: "<div><b>" + data.lstdoccpt.length + "</b> facture" + (data.lstdoccpt.length > 1 ? "s" : "") + " de vente</div>",
                        icon: "fafa fafa-file-invoice-euro",
                        lstData: data.lstdoccpt,
                        funcRempli: function (lstData, contentElement) {
                            contentElement.css("padding-left", "30px")
                            lstData.forEach(function (dataTemplateDocCpt, idx) {
                                var $Div = $("<div style='margin:10px;padding:10px;border:" + theme.border + ";box-shadow: 0 0 5px 0.5px rgba(0, 0, 0, 0.5);position:relative;' class='state-hover'/>").appendTo(contentElement)
                                bddRef.getObjet("doc_cpt").itemTemplateGrille($Div, dataTemplateDocCpt)
                                var dxBt = $("<div style='position:absolute;bottom:5px;right:calc(50% - 20px);display:none;z-index:2;opacity:1;'/>").appendTo($Div).dxCtrlButton({
                                    hint: "J'ai vu cette facture, ne plus me l'afficher jusqu'au prochaine changement de statut.",
                                    icon: "fas fa-eye-low-vision",
                                    colorIcone: theme.backgroundcolorAccent,
                                    onClick: function (e) {
                                        e.event.stopPropagation()
                                        $Div.slideUp(200, function () { $Div.remove() })
                                        var obj = bddRef.getObjet("doc_cpt", dataTemplateDocCpt.id_doc_cpt)
                                        obj.data.facturx_id_statut_vu = obj.data.facturx_id_statut
                                        obj.mSaveChamp("facturx_id_statut_vu")
                                    },
                                    onContentReady: function (e) {
                                        window.setTimeout(function () { dxBt.element().css("opacity", "1") }, 0)
                                    }
                                }).dxCtrlButton("instance")
                                $Div.on("mouseenter", function () { dxBt.element().show() })
                                $Div.on("mouseleave", function () { dxBt.element().hide() })
                                $Div.on("click", function (e) {
                                    var obj = bddRef.getObjet("doc_cpt", dataTemplateDocCpt.id_doc_cpt)
                                    obj.mShowPopup()
                                })
                            })
                        }
                    })
                }
                //facturxReception
                if (data.lstfacturxreception && data.lstfacturxreception.length > 0) {
                    resultDs.push({
                        title: "<div><b>" + data.lstfacturxreception.length + "</b> facture" + (data.lstfacturxreception.length > 1 ? "s" : "") + " d'achat</div>",
                        icon: "fafa fafa-invoice-achat",
                        lstData: data.lstfacturxreception,
                        funcRempli: function (lstData, contentElement) {
                            contentElement.css("padding-left", "30px")
                            lstData.forEach(function (dataTemplateFactXReception, idx) {
                                var $Div = $("<div style='margin:10px;padding:10px;border:" + theme.border + ";box-shadow: 0 0 5px 0.5px rgba(0, 0, 0, 0.5);position:relative;'/>").appendTo(contentElement)
                                bddRef.getObjet("facturx_reception").itemTemplateGrille($Div, dataTemplateFactXReception)
                                var dxBt = $("<div style='position:absolute;bottom:5px;right:calc(50% - 20px);display:none;z-index:2;opacity:1;'/>").appendTo($Div).dxCtrlButton({
                                    hint: "J'ai vu cette facture, ne plus me l'afficher jusqu'au prochaine changement de statut.",
                                    icon: "fas fa-eye-low-vision",
                                    colorIcone: theme.backgroundcolorAccent,
                                    onClick: function (e) {
                                        $Div.slideUp(200, function () { $Div.remove() })
                                        var obj = bddRef.getObjet("facturx_reception", dataTemplateFactXReception.id_facturx_reception)
                                        obj.data.facturx_id_statut_vu = obj.data.facturx_id_statut
                                        obj.mSaveChamp("facturx_id_statut_vu")
                                    },
                                    onContentReady: function (e) {
                                        window.setTimeout(function () { dxBt.element().css("opacity", "1") }, 0)
                                    }
                                }).dxCtrlButton("instance")
                                $Div.on("mouseenter", function () { dxBt.element().show() })
                                $Div.on("mouseleave", function () { dxBt.element().hide() })
                            })
                        }
                    })
                }
                //email recu 
                dsNbEmail = data.nbemail;
                dsNbEmailErreur = ((typeof data.nbemailerreur == 'undefined') ? [] : data.nbemailerreur);
                var oldLstHistoMailErreur = JSON.parse(JSON.stringify(lstHistoMailErreur))
                lstHistoMailErreur = []
                if (dsNbEmailErreur) {
                    dsNbEmailErreur.forEach(function (dataEmail) {
                        dataEmail.lst_id_com_email_envoi.split("|").forEach(function (idComEmeilEnvoi) {
                            if (idComEmeilEnvoi.length > 0 && !lstHistoMailErreur.contains(idComEmeilEnvoi)) lstHistoMailErreur.push(idComEmeilEnvoi)
                        })
                    })
                }
                changeEmailErreur = (lstHistoMailErreur.filter(x => !oldLstHistoMailErreur.includes(x)).length > 0)
                //var changeEmailErreur = (JSON.stringify(dsNbEmailErreur) != JSON.stringify(oldDsNbEmailErreur))
                if (typeof dsNbEmail != 'undefined') {
                    if (JSON.stringify(dsNbEmail) != JSON.stringify(oldDsNbEmail) || JSON.stringify(dsNbEmailErreur) != JSON.stringify(oldDsNbEmailErreur)) {
                        $(window).trigger("changeNbEmail");
                        var dataNonLu = dsNbEmail.filter(function (o) { return o.adresse_email == 'favori' && o.id_type_classement == "1" && o.nouveau == 1 })[0]
                        if (typeof dataNonLu == 'undefined' || dataNonLu.nb == 0) { document.title = parametre.nom }
                        else { document.title = parametre.nom + " (" + dataNonLu.nb + ")" }
                        oldDsNbEmail = dsNbEmail
                        oldDsNbEmailErreur = dsNbEmailErreur
                    }
                    if (oldDsNbEmail == null) oldDsNbEmail = JSON.parse(JSON.stringify(dsNbEmail))
                    if (oldDsNbEmailErreur == null) oldDsNbEmailErreur = JSON.parse(JSON.stringify(dsNbEmailErreur))
                    if (JSON.parse(JSON.stringify(dsNbEmail)) != JSON.parse(JSON.stringify(oldDsNbEmail))) {
                        bddRef.utiCourantParaJson.last_id_com_email_recu = data.maxidemail
                        bddRef.mSaveParaJsonUtilisateur();
                        if (typeof data.id_com_email_recu != 'undefined') {
                            var lstIdComEmailRecu = data.id_com_email_recu.filter(function (itemData) {
                                return LstIdComEmailRecuVisu.filter(function (id2) { return itemData.id == id2 }).length == 0
                            })
                            var lstCompteEmailEnAttente = bddRef.mGetArray("compte_email").filter(function (itemData) { return itemData.nb_email_total_to_load == null })
                            var lstIdComEmailRecuForPopup = lstIdComEmailRecu.filter(function (itemData) {
                                return lstCompteEmailEnAttente.filter(function (itemDataCptEmail) { return itemData.id_compte_email == itemDataCptEmail.id_compte_email }).length > 0
                            })
                            if ((typeof bddRef.utiCourantParaJson.parametre_general.popup_email_recu_on == 'undefined' ||
                                bddRef.utiCourantParaJson.parametre_general.popup_email_recu_on) &&
                                lstIdComEmailRecuForPopup.length > 0 && !page.mHasPopupFullScreenOrShading() &&
                                parametre.isDesktop) {

                                if (firstDisplayDemarrage) {
                                    resultDs.push({
                                        title: "<div>Vous avez reçu <b>" + lstIdComEmailRecu.length + "</b>" + (lstIdComEmailRecu.length > 1 ? " nouveaux messages" : " nouveau message") + "</div>",
                                        icon: "fas fa-envelope-open-text",
                                        lstData: lstIdComEmailRecu,
                                        funcRempli: function (lstData, contentElement) {
                                            contentElement.css("padding-left", "30px")
                                            var height = 0
                                            var emoji = "📩"
                                            var lstIdTableId = []
                                            lstData.forEach(function (comEmail, idx) {
                                                var $Table = $("<table style='width:100%;;font-family:barlow condensed;table-layout:fixed;margin-bottom:5px;' class='state-hover'/>").appendTo(contentElement)
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;'/>").appendTo($Tr)
                                                $("<span>" + comEmail.date_reception.toDateIlya(true) + "</span>").appendTo($Td)
                                                $("<span> &bull; </span>").appendTo($Td)
                                                $("<u>" + comEmail.email_expediteur + "</u>").appendTo($Td)
                                                $("<span> &bull; </span>").appendTo($Td)
                                                $("<u style='opacity:0.3;'>" + comEmail.email_destinataire + "</u>").appendTo($Td)
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;font-style:italic;border-bottom:" + theme.border + ";'/>").appendTo($Tr).text(comEmail.objet)

                                                $Table.on("click", function (e) {
                                                    bddRef.getObjet("com_email_recu", comEmail.id_com_email_recu).mShowPopup()
                                                })
                                                height += 47
                                            })
                                        }
                                    })
                                } else {
                                    messagePopup.mShow({
                                        bddCtrl: bddRef,
                                        son: "email",
                                        tempoSeconde: 10 + lstIdComEmailRecu.length * 2,
                                        icone: "<i class='fas fa-envelope-open-text' style='font-size:200%'></i>",
                                        message: function (contentElement) {
                                            $("<div>Vous avez reçu <b>" + lstIdComEmailRecu.length + "</b>" + (lstIdComEmailRecu.length > 1 ? " nouveaux messages" : " nouveau message") + "</div>").appendTo(contentElement)

                                            var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                                            var $Table = $("<table style='width:100%;font-family:barlow condensed;table-layout:fixed;'/>").appendTo(dxScroll.content())
                                            var height = 0
                                            var emoji = "📩"
                                            var lstIdTableId = []
                                            lstIdComEmailRecu.forEach(function (comEmail, idx) {
                                                var $Table = $("<table style='width:100%;;font-family:barlow condensed;table-layout:fixed;margin-bottom:5px;' class='state-hover'/>").appendTo(dxScroll.content())
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;'/>").appendTo($Tr)
                                                $("<span>" + comEmail.date_reception.toDateIlya(true) + "</span>").appendTo($Td)
                                                $("<span> &bull; </span>").appendTo($Td)
                                                $("<u>" + comEmail.email_expediteur + "</u>").appendTo($Td)
                                                $("<span> &bull; </span>").appendTo($Td)
                                                $("<u style='opacity:0.3;'>" + comEmail.email_destinataire + "</u>").appendTo($Td)
                                                var $Tr = $("<tr/>").appendTo($Table)
                                                var $Td = $("<td style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;font-style:italic;border-bottom:" + theme.border + ";'/>").appendTo($Tr).text(comEmail.objet)

                                                $Table.on("click", function (e) {
                                                    bddRef.getObjet("com_email_recu", comEmail.id_com_email_recu).mShowPopup()
                                                })
                                                height += 47

                                            })
                                            if (height > $(document).height() / 3) { dxScroll.element().css("height", ($(document).height() / 3) + "px") }
                                            else { dxScroll.element().css("height", height + "px") }
                                        }
                                    })
                                }
                            }
                            if (lstIdComEmailRecu.length > 0) $(document).trigger('receptionEmailEvent', { result: lstIdComEmailRecu });
                        }

                        dsNbEmail.filter(function (o) {
                            return o.id_type_classement == 11
                        }).forEach(function (o) {
                            if (o.adresse_email != "favori") {
                                if (typeof nbEmailErreur[o.adresse_email] == "undefined" || parseInt(nbEmailErreur[o.adresse_email].nb) < parseInt(o.nb)) {
                                    //on a jamais signalé les erreurs ou il y a une erreur de plus
                                    var nbNew = 0
                                    if (typeof nbEmailErreur[o.adresse_email] == "undefined") {
                                        //on a jamais signalé les erreurs (démarrage)
                                        nbNew = o.nb
                                    } else {
                                        //on a un nouvel email en erreur
                                        nbNew = parseInt(nbEmailErreur[o.adresse_email].nb) - parseInt(o.nb)
                                    }
                                    if (nbNew > 0 && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                                        messagePopup.mShow({
                                            bddCtrl: bddRef,
                                            son: "pop",
                                            icone: "<i class='fas fa-envelope' style='font-size:200%;position:relative'><i class='fas fa-triangle-exclamation' style='position:absolute;bottom:-5px;right:-8px;opacity:1;font-size:65%;color:red'></i></i>",
                                            message: function (contentElement, popup) {
                                                contentElement.css("height", "70px")
                                                if (nbNew > 1) {
                                                    $("<div>Vous avez des emails en erreur sur l'adresse email <u>" + o.adresse_email + "</u>. Ceux-ci n'ont pas pu être envoyé.<br/>Cliquez pour les afficher.</div>").appendTo(contentElement)
                                                } else {
                                                    $("<div>Vous avez un email en erreur sur l'adresse email <u>" + o.adresse_email + "</u>. Celui-ci n'a pas pu être envoyé.<br/>Cliquez pour l'afficher.</div>").appendTo(contentElement)
                                                }
                                                contentElement.addClass("state-hover")
                                                contentElement.css("cursor", "pointer")
                                                contentElement.on("click", function () {
                                                    page.mShowMenu("lstemail", {
                                                        adresse_email: o.adresse_email,
                                                        id_type_classement: 11
                                                    })
                                                    popup.hide()
                                                })
                                            },
                                            tempoSeconde: 10000
                                        })
                                    }
                                }
                                nbEmailErreur[o.adresse_email] = o
                            }
                        })
                    }
                }

                //email vue
                if (typeof data.lst_id_com_email_envoi_tracking_vue != 'undefined' && data.lst_id_com_email_envoi_tracking_vue.length > 0) {
                    var afficheMessage = (typeof bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_vue != 'undefined')
                    bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_vue = data.lst_id_com_email_envoi_tracking_vue[0].id_com_email_envoi_tracking_vue
                    bddRef.mSaveParaJsonUtilisateur();
                    if ((typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on == 'undefined' ||
                        bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_vue_on) &&
                        afficheMessage && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                        //if (data.lst_id_com_email_envoi_tracking_vue.length > 2) {

                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div><b>" + data.lst_id_com_email_envoi_tracking_vue.length + "</b> " + (data.lst_id_com_email_envoi_tracking_vue.length > 1 ? "nouveaux trackings vues email" : "nouveau tracking vue email") + "</div>",
                                icon: "fas fa-eye",
                                lstData: data.lst_id_com_email_envoi_tracking_vue,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("padding-left", "30px")
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div>Afficher les fiches</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)
                                    mRempliTracking(lstData, contentElement, $TdBt, "com_email_envoi", true)
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "info",
                                tempoSeconde: 10 + data.lst_id_com_email_envoi_tracking_vue.length * 2,
                                titre: "Tracking vue email",
                                icone: "<i class='fas fa-eye' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div><b>" + data.lst_id_com_email_envoi_tracking_vue.length + "</b> " + (data.lst_id_com_email_envoi_tracking_vue.length > 1 ? "nouveaux trackings vues email" : "nouveau tracking vue email") + "</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)

                                    mRempliTracking(data.lst_id_com_email_envoi_tracking_vue, contentElement, $TdBt, "com_email_envoi", false)
                                }
                            })
                        }
                    }
                }

                //email click
                if (typeof data.lst_id_com_email_envoi_tracking_click != 'undefined' && data.lst_id_com_email_envoi_tracking_click.length > 0) {
                    var afficheMessage = (typeof bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_click != 'undefined')
                    bddRef.utiCourantParaJson.last_id_com_email_envoi_tracking_click = data.lst_id_com_email_envoi_tracking_click[0].id_com_email_envoi_tracking_click
                    bddRef.mSaveParaJsonUtilisateur();
                    if ((typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on == 'undefined' ||
                        bddRef.utiCourantParaJson.parametre_general.popup_tracking_email_click_on) &&
                        afficheMessage && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                        //if (data.lst_id_com_email_envoi_tracking_click.length > 2) {

                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div><b>" + data.lst_id_com_email_envoi_tracking_click.length + "</b> " + (data.lst_id_com_email_envoi_tracking_click.length > 1 ? "nouveaux trackings click email" : "nouveau tracking click email") + "</div>",
                                icon: "fas fa-arrow-pointer",
                                lstData: data.lst_id_com_email_envoi_tracking_click,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("padding-left", "30px")
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div>Afficher les fiches</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)
                                    mRempliTracking(lstData, contentElement, $TdBt, "com_email_envoi", true)
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                titre: "Tracking click email",
                                son: "flute",
                                tempoSeconde: 10 + data.lst_id_com_email_envoi_tracking_click.length * 2,
                                icone: "<i class='fas fa-arrow-pointer' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div><b>" + data.lst_id_com_email_envoi_tracking_click.length + "</b> " + (data.lst_id_com_email_envoi_tracking_click.length > 1 ? "nouveaux trackings clicks email" : "nouveau tracking click email") + "</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)

                                    mRempliTracking(data.lst_id_com_email_envoi_tracking_click, contentElement, $TdBt, "com_email_envoi", false)
                                }
                            })
                        }
                    }
                }

                //sms vue
                if (typeof data.lst_id_com_sms_envoi_tracking_vue != 'undefined' && data.lst_id_com_sms_envoi_tracking_vue.length > 0) {
                    var afficheMessage = (typeof bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_vue != 'undefined')
                    bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_vue = data.lst_id_com_sms_envoi_tracking_vue[0].id_com_sms_envoi_tracking_vue
                    bddRef.mSaveParaJsonUtilisateur();
                    if ((typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on == 'undefined' ||
                        bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_vue_on) &&
                        afficheMessage && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                        //if (data.lst_id_com_sms_envoi_tracking_vue.length > 2) {
                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div><b>" + data.lst_id_com_sms_envoi_tracking_vue.length + "</b> " + (data.lst_id_com_sms_envoi_tracking_vue.length > 1 ? "nouveaux trackings click email" : "nouveau tracking click email") + "</div>",
                                icon: "fas fa-eye",
                                lstData: data.lst_id_com_sms_envoi_tracking_vue,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("padding-left", "30px")
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div>Afficher les fiches</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)
                                    mRempliTracking(lstData, contentElement, $TdBt, "com_sms_envoi", true)
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "info",
                                titre: "Tracking vue sms",
                                tempoSeconde: 10 + data.lst_id_com_sms_envoi_tracking_vue.length * 2,
                                icone: "<i class='fas fa-eye' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div><b>" + data.lst_id_com_sms_envoi_tracking_vue.length + "</b> " + (data.lst_id_com_sms_envoi_tracking_vue.length > 1 ? "nouveaux trackings vues SMS" : "nouveau tracking vue SMS") + "</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)

                                    mRempliTracking(data.lst_id_com_sms_envoi_tracking_vue, contentElement, $TdBt, "com_sms_envoi", false)
                                }
                            })
                        }
                    }
                }

                //sms click
                if (typeof data.lst_id_com_sms_envoi_tracking_click != 'undefined' && data.lst_id_com_sms_envoi_tracking_click.length > 0) {
                    var afficheMessage = (typeof bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_click != 'undefined')
                    bddRef.utiCourantParaJson.last_id_com_sms_envoi_tracking_click = data.lst_id_com_sms_envoi_tracking_click[0].id_com_sms_envoi_tracking_click
                    bddRef.mSaveParaJsonUtilisateur();
                    if ((typeof bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on == 'undefined' ||
                        bddRef.utiCourantParaJson.parametre_general.popup_tracking_sms_click_on) &&
                        afficheMessage && !page.mHasPopupFullScreenOrShading() && parametre.isDesktop) {
                        //if (data.lst_id_com_sms_envoi_tracking_click.length > 2) {
                        if (firstDisplayDemarrage) {
                            resultDs.push({
                                title: "<div><b>" + data.lst_id_com_sms_envoi_tracking_click.length + "</b> " + (data.lst_id_com_sms_envoi_tracking_click.length > 1 ? "nouveaux trackings click email" : "nouveau tracking click email") + "</div>",
                                icon: "fas fa-arrow-pointer",
                                lstData: data.lst_id_com_sms_envoi_tracking_click,
                                funcRempli: function (lstData, contentElement) {
                                    contentElement.css("padding-left", "30px")
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div>Afficher les fiches</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)
                                    mRempliTracking(lstData, contentElement, $TdBt, "com_sms_envoi", true)
                                }
                            })
                        } else {
                            messagePopup.mShow({
                                bddCtrl: bddRef,
                                son: "flute",
                                titre: "Tracking click sms",
                                tempoSeconde: 10 + data.lst_id_com_sms_envoi_tracking_click.length * 2,
                                icone: "<i class='fas fa-arrow-pointer' style='font-size:200%'></i>",
                                message: function (contentElement) {
                                    var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(contentElement)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    var $Td = $("<td style='width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;'/>").appendTo($Tr)
                                    $("<div><b>" + data.lst_id_com_sms_envoi_tracking_click.length + "</b> " + (data.lst_id_com_sms_envoi_tracking_click.length > 1 ? "nouveaux trackings clicks SMS" : "nouveau tracking click SMS") + "</div>").appendTo($Td)
                                    var $TdBt = $("<td style='width:40px'/>").appendTo($Tr)

                                    mRempliTracking(data.lst_id_com_sms_envoi_tracking_click, contentElement, $TdBt, "com_sms_envoi", false)
                                }
                            })
                        }
                    }
                }

                if (changeEmailErreur) {
                    var dsNbEmailErr = Me.mGetDsEmailErreur(null, null, [9, 13])
                    if (dsNbEmailErr.nb > 0) {
                        messagePopup.mShow({
                            bddCtrl: bddRef,
                            son: "attention",
                            titre: "Envoi en erreur",
                            icone: "<i class='fas fa-triangle-exclamation blinkscalealways' style='font-size:200%;color:red'></i>",
                            message: function (contentElement, popup) {
                                contentElement.css("height", "40px")
                                contentElement.addClass("popupmsg")
                                $("<div style='font-size:120%;padding-left:10px;'>Vous avez <b style='color:red'>" + dsNbEmailErr.nb + "</b> message" + ((dsNbEmailErr.nb > 1) ? "s" : "") + " en erreur dans votre boite d'envoi.</div>").appendTo(contentElement)
                                var lstId = []
                                dsNbEmailErr.lstData.forEach(function (data) {
                                    data.lst_id_com_email_envoi.split("|").forEach(function (id) {
                                        if (!lstId.contains(id)) lstId.push(id)
                                    })
                                })
                                if (lstId.length < 10) {
                                    $A = $("<a href='javascript:void(0)'>Ouvrir " + ((lstId.length > 1) ? "les messages" : "le message") + " en erreur</a>").appendTo(contentElement)
                                    $A.on("click", function () {
                                        popup.hide()
                                        lstId.forEach(function (id) {
                                            bddRef.getObjet("com_email_envoi", id).mShowPopup()
                                        })
                                    })
                                }
                            },
                            tempoSeconde: 16
                        })
                    }
                }

                if (firstDisplayDemarrage) {
                    firstDisplayDemarrage = false
                    //var dsNbEmailErr = Me.mGetDsEmailErreur(null, null, [9, 13])
                    //if (dsNbEmailErr.nb > 0) {
                    //    messagePopup.mShow({
                    //        bddCtrl: bddRef,
                    //        son: "attention",
                    //        titre: "Envoi en erreur",
                    //        icone: "<i class='fas fa-triangle-exclamation blinkscalealways' style='font-size:200%;color:red'></i>",
                    //        message: function (contentElement, popup) {
                    //            contentElement.css("height", "40px")
                    //            contentElement.addClass("popupmsg")
                    //            $("<div style='font-size:120%;padding-left:10px;'>Vous avez <b style='color:red'>" + dsNbEmailErr.nb + "</b> message" + ((dsNbEmailErr.nb > 1) ? "s" : "") + " en erreur dans votre boite d'envoi.</div>").appendTo(contentElement)
                    //            var lstId = []
                    //            dsNbEmailErr.lstData.forEach(function (data) {
                    //                data.lst_id_com_email_envoi.split("|").forEach(function (id) {
                    //                    if (!lstId.contains(id)) lstId.push(id)
                    //                })
                    //            })
                    //            if (lstId.length < 10) {
                    //                $A = $("<a href='javascript:void(0)'>Ouvrir " + ((lstId.length > 1) ? "les messages" : "le message") + " en erreur</a>").appendTo(contentElement)
                    //                $A.on("click", function () {
                    //                    popup.hide()
                    //                    lstId.forEach(function (id) {
                    //                        bddRef.getObjet("com_email_envoi", id).mShowPopup()
                    //                    })
                    //                })
                    //            }
                    //        },
                    //        tempoSeconde: 16
                    //    })
                    //}
                    if (resultDs.length > 0) {
                        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            position: {
                                my: "right top",
                                at: "right top",
                                of: "body"
                            },
                            hideOnOutsideClick: false,
                            width: 550,
                            height: "100%",
                            showTitle: true,
                            showMaximize: false,
                            shading: false,
                            title: "Actualités",
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "0 20px 20px 20px")
                                var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                                $("<div/>").appendTo(dxScroll.content()).dxAccordion({
                                    dataSource: resultDs,
                                    multiple: true,
                                    collapsible: true,
                                    animationDuration: 300,
                                    deferRendering: true,   // le contenu n'est construit qu'à l'ouverture du panneau
                                    noDataText: "Aucun résultat",
                                    selectedItems: resultDs,
                                    itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                                        // title contient du HTML (ex: "<b>3</b> nouveaux trackings...")
                                        itemElement.addClass("dx-theme-accent-as-text-color").css("font-size", "120%")
                                        itemElement.css("line-height", "1")
                                        var $Table = $("<table style='width:95%:'/>").appendTo(itemElement)
                                        var $Tr = $("<tr/>").appendTo($Table)
                                        var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                                        $Td.html("<i class='" + itemData.icon + "' style='font-size:120%'></i>")
                                        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                                        $Td.html(itemData.title);
                                        itemData.titleElementText = $Td
                                    },
                                    itemTemplate: function (itemData, itemIndex, itemElement) {
                                        var $content = $(itemElement);
                                        $content.css("padding-top", "0")
                                        // on réutilise directement votre fonction de rendu existante
                                        itemData.funcRempli(itemData.lstData, $content, itemData.titleElementText);
                                    }
                                })
                            }
                        }).dxCtrlPopupBase("instance")
                        popup.show()
                    }
                }

                timeOutGetData = window.setTimeout(function () { Me.mGetData() }, tempoGetData)
            })
        } else {
            nbCallSansClick += 1
            //console.log("nbCallSansClick = " + nbCallSansClick)
            timeOutGetData = window.setTimeout(function () { Me.mGetData() }, tempoGetData)
        }
    }

    function mRempliTracking(lstData, contentElement, $TdBt, nomTable, inPopup) {
        if (!inPopup) {
            var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
            contentElement = dxScroll.content()
        }
        //var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
        var $Table = $("<table style='width:100%;font-family:barlow condensed;table-layout:fixed;'/>").appendTo(contentElement)
        var height = 0
        var idCurrent = null
        var emoji = "📧"
        if (nomTable == "com_sms_envoi") emoji = "💬"
        var lstIdTableId = []
        lstData.forEach(function (vue, idx) {
            if (idCurrent != vue["id_" + nomTable]) {
                idCurrent = vue["id_" + nomTable]
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='overflow:hidden;white-space:nowrap;text-overflow:ellipsis;' class='state-hover'/>").appendTo($Tr)
                $("<span>" + emoji + "</span>").appendTo($Td)
                $("<span style='font-style:italic;'></span>").appendTo($Td).text(" " + vue.objet).attr("title", vue.objet)
                $Td.css("border-top", theme.border)
                $Td.on("click", function (e) { bddRef.getObjet(nomTable, vue["id_" + nomTable]).mShowPopup() })
                height += 23
            }

            var $Tr = $("<tr/>").appendTo($Table)
            var lib = ""
            if (vue.id_table) {
                if (vue.nom_str) lib = vue.nom_str
                if (vue.con_nom || vue.con_prenom) {
                    if (vue.nom_str) lib = " ☉ "
                    lib += (vue.con_nom ? vue.con_nom : "") + " " + (vue.con_prenom ? vue.con_prenom : "")
                }
                if (lib.length == 0) lib = vue.coord
                lstIdTableId.push({ id_table: vue.id_table, id: vue.id })
            } else { lib = vue.coord }

            var $Td = $("<td style='overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding-left:18px;'/>").appendTo($Tr)
            $("<span></span>").appendTo($Td).text(vue.dcr.toDateIlya(true)).attr("title", vue.dcr.toFrenchDateTime())
            $("<span> &bull; </span>").appendTo($Td)
            $("<span style='font-weight:bold;'></span>").appendTo($Td).text(lib).attr("title", lib)
            if (vue.id_table) {
                $Td.addClass('state-hover')
                $Td.on("click", function (e) { bddRef.getObjet(bddRef.table.mGetItem(vue.id_table).nom, vue.id).mShowPopup() })
            }
            height += 24
        })
        if (!inPopup) {
            if (height > $(document).height() / 3) { dxScroll.element().css("height", ($(document).height() / 3) + "px") }
            else { dxScroll.element().css("height", height + "px") }
        }

        $("<div/>").appendTo($TdBt).dxCtrlButton({
            icon: "fas fa-bars-staggered",
            icon2: "fas fa-ellipsis",
            colorIcone2: theme.colorBtIcon2,
            opacityIcone2: "0.9",
            hint: "Afficher la liste des fiches",
            height: 24,
            width: 24,
            onClick: function (e) {
                page.mAddPopupLst("Liste fiches tracking vue email", function (contentElement) {
                    $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                        bddCtrl: bddRef,
                        lstIdTableIdInclu: lstIdTableId
                    })
                })
            }
        })
    }

    this.nbRappel = 0
    this.lstIdRappelPrevenu = []
    function mGetDataSourceRappel() {
        var lstUtiRapp = bddRef.mGetArray("rappel_utilisateur").filter(function (utiRap) { return utiRap.id_utilisateur == bddRef.utiCourant.id_utilisateur })
        var ds = bddRef.mGetArray("rappel").filter(function (rappel) {
            if (rappel.fini != "1" && lstUtiRapp.filter(function (utiRap) { return utiRap.id_rappel == rappel.id_rappel }).length > 0) {
                return rappel.date_debut <= (new Date(parametre.dateNow)) && !Me.lstIdRappelPrevenu.contains(rappel.id_rappel)
            } else { return false }
        })
        ds.forEach(function (rappel) {
            if (!Me.lstIdRappelPrevenu.contains(rappel.id_rappel)) Me.lstIdRappelPrevenu.push(rappel.id_rappel)
        })
        if (this.nbRappel != ds.length) {
            this.nbRappel = ds.length
            $(window).trigger("updateRappel", [this.nbRappel]);
        }
        return ds
    }

    var lstIdSondageReponsePrevenu = []
    function mGetDataSourceSondage() {
        var ds = bddRef.mGetArray("sondage_reponse").filter(function (sondRep) {
            return sondRep.vue == "0" &&
                !lstIdSondageReponsePrevenu.contains(sondRep.id_sondage_reponse) &&
                bddRef.getObjet("sondage", sondRep.id_sondage).data.id_utilisateur == bddRef.utiCourant.id_utilisateur
        })
        ds.forEach(function (sondRep) {
            if (!lstIdSondageReponsePrevenu.contains(sondRep.id_sondage_reponse)) lstIdSondageReponsePrevenu.push(sondRep.id_sondage_reponse)
        })
        return ds
    }

    var lstIdFormulaireReponsePrevenu = []
    function mGetDataSourceFormulaire() {
        var ds = bddRef.mGetArray("formulaire_reponse").filter(function (formRep) {
            return formRep.vue == "0" &&
                !lstIdFormulaireReponsePrevenu.contains(formRep.id_formulaire_reponse) &&
                bddRef.getObjet("formulaire", formRep.id_formulaire).data.id_utilisateur == bddRef.utiCourant.id_utilisateur
        })
        ds.forEach(function (formRep) {
            if (!lstIdFormulaireReponsePrevenu.contains(formRep.id_sondage_reponse)) lstIdFormulaireReponsePrevenu.push(formRep.id_formulaire_reponse)
        })
        return ds
    }

    if (typeof bddRef.utiCourant != 'undefined' && bddRef.utiCourant != null) {
        bddRef.mAddFunctionOnModifiedItemData(["compte_email", "compte_email_utilisateur", "com_email_envoi"], null,
            function (action, itemData) { hasClickBody = true; Me.mGetData() })
    }

    this.mGetHtmlEtTooltipForEmailNb = function (nbRecu, nbErreur) {
        var txtRecu = ""
        var txtErreur = ""
        var tooltip = ""
        if (nbRecu > 999) { txtRecu = "∾" }
        else { txtRecu = ((nbRecu == 0) ? "" : nbRecu.toString()) }
        if (nbRecu > 0) tooltip = "<b>" + nbRecu + "</b> email" + ((nbRecu > 1) ? "s" : "") + " non lu" + ((nbRecu > 1) ? "s" : "") + ""
        if (nbErreur > 999) { txtErreur = "∾" }
        else { txtErreur = ((nbErreur == 0) ? "" : nbErreur.toString()) }
        if (txtRecu.length > 0) txtRecu = "<span style=''>" + txtRecu + "</span>"
        if (txtErreur.length > 0) txtErreur = "<div style='color:red;display:inline-block;' class='blinkscalealwaysbig'>" + txtErreur + "</div>"
        if (nbErreur > 0) tooltip += ((tooltip.length > 0) ? "<br/>" : "") + "<span style='color:red'><b>" + nbErreur + "</b> email" + ((nbErreur > 1) ? "s" : "") + " en erreur</span>"
        var txtTotal = ""
        if (txtRecu.length > 0 && txtErreur.length > 0) { txtTotal = txtRecu + "<span style='opacity:0.3;'>/</span>" + txtErreur }
        else if (txtErreur.length > 0) { txtTotal = "0<span style='opacity:0.3;'>/</span>" + txtErreur }
        else { txtTotal = txtRecu }
        return { html: txtTotal, title: tooltip }
    }

}